import React, { useState } from 'react'
import "../../css/AdminSettings.css"

function AdminSettings() {
  const [activeTab, setActiveTab] = useState('general');
  const [saveStatus, setSaveStatus] = useState('');
  
  // Mock school data - replace with your actual data source
  const schoolData = {
    name: "Springfield High School",
    address: "123 Education Blvd, Springfield",
    email: "admin@springfield.edu",
    phone: "+1 (555) 987-6543",
    principal: "Dr. Jane Smith",
    website: "www.springfieldhigh.edu",
    establishedYear: "1985",
    schoolLogo: "/api/placeholder/120/120"
  };

  const handleSave = (tabName) => {
    setSaveStatus(`${tabName} settings saved successfully!`);
    setTimeout(() => setSaveStatus(''), 3000);
  };

  return (
    <div className="admin-settings-container">
      <div className="admin-settings-header">
        <h1 className="admin-settings-title">System Administration</h1>
        <p className="admin-settings-subtitle">Configure school settings and system preferences</p>
      </div>
      
      {saveStatus && (
        <div className="admin-settings-alert admin-settings-alert-success">
          <span className="admin-settings-alert-icon">✓</span>
          {saveStatus}
        </div>
      )}
      
      <div className="admin-settings-content">
        <div className="admin-settings-sidebar">
          <div className="admin-settings-school-info">
            <img src={schoolData.schoolLogo} alt="School Logo" className="admin-settings-school-logo" />
            <div className="admin-settings-school-name">{schoolData.name}</div>
          </div>
          
          <ul className="admin-settings-menu">
            <li 
              className={`admin-settings-menu-item ${activeTab === 'general' ? 'admin-settings-menu-item-active' : ''}`}
              onClick={() => setActiveTab('general')}
            >
              <span className="admin-settings-menu-icon">⚙️</span>
              General Settings
            </li>
            <li 
              className={`admin-settings-menu-item ${activeTab === 'users' ? 'admin-settings-menu-item-active' : ''}`}
              onClick={() => setActiveTab('users')}
            >
              <span className="admin-settings-menu-icon">👥</span>
              User Management
            </li>
            <li 
              className={`admin-settings-menu-item ${activeTab === 'academic' ? 'admin-settings-menu-item-active' : ''}`}
              onClick={() => setActiveTab('academic')}
            >
              <span className="admin-settings-menu-icon">📚</span>
              Academic Settings
            </li>
            <li 
              className={`admin-settings-menu-item ${activeTab === 'notifications' ? 'admin-settings-menu-item-active' : ''}`}
              onClick={() => setActiveTab('notifications')}
            >
              <span className="admin-settings-menu-icon">🔔</span>
              Notification Settings
            </li>
            <li 
              className={`admin-settings-menu-item ${activeTab === 'security' ? 'admin-settings-menu-item-active' : ''}`}
              onClick={() => setActiveTab('security')}
            >
              <span className="admin-settings-menu-icon">🔒</span>
              Security & Permissions
            </li>
            <li 
              className={`admin-settings-menu-item ${activeTab === 'billing' ? 'admin-settings-menu-item-active' : ''}`}
              onClick={() => setActiveTab('billing')}
            >
              <span className="admin-settings-menu-icon">💰</span>
              Billing & Subscription
            </li>
            <li 
              className={`admin-settings-menu-item ${activeTab === 'integrations' ? 'admin-settings-menu-item-active' : ''}`}
              onClick={() => setActiveTab('integrations')}
            >
              <span className="admin-settings-menu-icon">🔌</span>
              Integrations
            </li>
            <li 
              className={`admin-settings-menu-item ${activeTab === 'logs' ? 'admin-settings-menu-item-active' : ''}`}
              onClick={() => setActiveTab('logs')}
            >
              <span className="admin-settings-menu-icon">📋</span>
              System Logs
            </li>
          </ul>
        </div>
        
        <div className="admin-settings-main">
          {activeTab === 'general' && (
            <div className="admin-settings-panel">
              <h2 className="admin-settings-panel-title">General Settings</h2>
              
              <div className="admin-settings-section">
                <h3 className="admin-settings-section-title">School Information</h3>
                <div className="admin-settings-form-group">
                  <label className="admin-settings-label">School Name</label>
                  <input type="text" className="admin-settings-input" defaultValue={schoolData.name} />
                </div>
                
                <div className="admin-settings-form-row">
                  <div className="admin-settings-form-group">
                    <label className="admin-settings-label">Email Address</label>
                    <input type="email" className="admin-settings-input" defaultValue={schoolData.email} />
                  </div>
                  <div className="admin-settings-form-group">
                    <label className="admin-settings-label">Phone Number</label>
                    <input type="tel" className="admin-settings-input" defaultValue={schoolData.phone} />
                  </div>
                </div>
                
                <div className="admin-settings-form-group">
                  <label className="admin-settings-label">School Address</label>
                  <input type="text" className="admin-settings-input" defaultValue={schoolData.address} />
                </div>
                
                <div className="admin-settings-form-row">
                  <div className="admin-settings-form-group">
                    <label className="admin-settings-label">Principal Name</label>
                    <input type="text" className="admin-settings-input" defaultValue={schoolData.principal} />
                  </div>
                  <div className="admin-settings-form-group">
                    <label className="admin-settings-label">Established Year</label>
                    <input type="text" className="admin-settings-input" defaultValue={schoolData.establishedYear} />
                  </div>
                </div>
                
                <div className="admin-settings-form-group">
                  <label className="admin-settings-label">School Website</label>
                  <input type="url" className="admin-settings-input" defaultValue={schoolData.website} />
                </div>
                
                <div className="admin-settings-form-group">
                  <label className="admin-settings-label">School Logo</label>
                  <div className="admin-settings-logo-upload">
                    <img src={schoolData.schoolLogo} alt="Current Logo" className="admin-settings-current-logo" />
                    <button className="admin-settings-upload-btn">Upload New Logo</button>
                  </div>
                </div>
              </div>
              
              <div className="admin-settings-section">
                <h3 className="admin-settings-section-title">System Preferences</h3>
                
                <div className="admin-settings-form-group">
                  <label className="admin-settings-label">Default Language</label>
                  <select className="admin-settings-select">
                    <option value="en">English</option>
                    <option value="es">Spanish</option>
                    <option value="fr">French</option>
                    <option value="de">German</option>
                  </select>
                </div>
                
                <div className="admin-settings-form-group">
                  <label className="admin-settings-label">Time Zone</label>
                  <select className="admin-settings-select">
                    <option value="utc-8">Pacific Time (UTC-8)</option>
                    <option value="utc-5">Eastern Time (UTC-5)</option>
                    <option value="utc">UTC</option>
                    <option value="utc+1">Central European Time (UTC+1)</option>
                    <option value="utc+5.5">Indian Standard Time (UTC+5:30)</option>
                  </select>
                </div>
                
                <div className="admin-settings-form-group">
                  <label className="admin-settings-label">Date Format</label>
                  <select className="admin-settings-select">
                    <option value="mm/dd/yyyy">MM/DD/YYYY</option>
                    <option value="dd/mm/yyyy">DD/MM/YYYY</option>
                    <option value="yyyy-mm-dd">YYYY-MM-DD</option>
                  </select>
                </div>
                
                <div className="admin-settings-form-group">
                  <div className="admin-settings-checkbox-wrapper">
                    <input type="checkbox" id="maintenance" className="admin-settings-checkbox" />
                    <label htmlFor="maintenance" className="admin-settings-checkbox-label">
                      Enable Maintenance Mode
                    </label>
                  </div>
                  <p className="admin-settings-help-text">When enabled, only administrators can access the system.</p>
                </div>
              </div>
              
              <div className="admin-settings-actions">
                <button className="admin-settings-cancel-btn">Cancel</button>
                <button 
                  className="admin-settings-save-btn"
                  onClick={() => handleSave("General")}
                >
                  Save Changes
                </button>
              </div>
            </div>
          )}
          
          {activeTab === 'users' && (
            <div className="admin-settings-panel">
              <h2 className="admin-settings-panel-title">User Management</h2>
              
              <div className="admin-settings-section">
                <h3 className="admin-settings-section-title">User Roles</h3>
                
                <div className="admin-settings-roles-list">
                  <div className="admin-settings-role-item">
                    <div className="admin-settings-role-header">
                      <h4 className="admin-settings-role-title">Administrator</h4>
                      <div className="admin-settings-role-actions">
                        <button className="admin-settings-role-edit">Edit</button>
                      </div>
                    </div>
                    <p className="admin-settings-role-description">
                      Full system access with ability to manage all aspects of the school management system.
                    </p>
                  </div>
                  
                  <div className="admin-settings-role-item">
                    <div className="admin-settings-role-header">
                      <h4 className="admin-settings-role-title">Teacher</h4>
                      <div className="admin-settings-role-actions">
                        <button className="admin-settings-role-edit">Edit</button>
                      </div>
                    </div>
                    <p className="admin-settings-role-description">
                      Can manage classes, grade assignments, take attendance, and communicate with students and parents.
                    </p>
                  </div>
                  
                  <div className="admin-settings-role-item">
                    <div className="admin-settings-role-header">
                      <h4 className="admin-settings-role-title">Student</h4>
                      <div className="admin-settings-role-actions">
                        <button className="admin-settings-role-edit">Edit</button>
                      </div>
                    </div>
                    <p className="admin-settings-role-description">
                      Can view their own academic information, assignments, and grades.
                    </p>
                  </div>
                  
                  <div className="admin-settings-role-item">
                    <div className="admin-settings-role-header">
                      <h4 className="admin-settings-role-title">Parent</h4>
                      <div className="admin-settings-role-actions">
                        <button className="admin-settings-role-edit">Edit</button>
                      </div>
                    </div>
                    <p className="admin-settings-role-description">
                      Can view their children's academic progress, attendance, and communicate with teachers.
                    </p>
                  </div>
                </div>
                
                <button className="admin-settings-add-role-btn">+ Add New Role</button>
              </div>
              
              <div className="admin-settings-section">
                <h3 className="admin-settings-section-title">User Registration</h3>
                
                <div className="admin-settings-form-group">
                  <div className="admin-settings-checkbox-wrapper">
                    <input type="checkbox" id="allow-registration" className="admin-settings-checkbox" checked />
                    <label htmlFor="allow-registration" className="admin-settings-checkbox-label">
                      Allow User Registration
                    </label>
                  </div>
                  <p className="admin-settings-help-text">When enabled, new users can register themselves.</p>
                </div>
                
                <div className="admin-settings-form-group">
                  <label className="admin-settings-label">Default Role for New Users</label>
                  <select className="admin-settings-select">
                    <option value="student">Student</option>
                    <option value="parent">Parent</option>
                    <option value="none">No role (require admin approval)</option>
                  </select>
                </div>
                
                <div className="admin-settings-form-group">
                  <div className="admin-settings-checkbox-wrapper">
                    <input type="checkbox" id="email-verification" className="admin-settings-checkbox" checked />
                    <label htmlFor="email-verification" className="admin-settings-checkbox-label">
                      Require Email Verification
                    </label>
                  </div>
                </div>
                
                <div className="admin-settings-form-group">
                  <div className="admin-settings-checkbox-wrapper">
                    <input type="checkbox" id="admin-approval" className="admin-settings-checkbox" />
                    <label htmlFor="admin-approval" className="admin-settings-checkbox-label">
                      Require Admin Approval
                    </label>
                  </div>
                </div>
              </div>
              
              <div className="admin-settings-actions">
                <button className="admin-settings-cancel-btn">Cancel</button>
                <button 
                  className="admin-settings-save-btn"
                  onClick={() => handleSave("User Management")}
                >
                  Save Changes
                </button>
              </div>
            </div>
          )}
          
          {activeTab === 'security' && (
            <div className="admin-settings-panel">
              <h2 className="admin-settings-panel-title">Security & Permissions</h2>
              
              <div className="admin-settings-section">
                <h3 className="admin-settings-section-title">Password Policy</h3>
                
                <div className="admin-settings-form-group">
                  <label className="admin-settings-label">Minimum Password Length</label>
                  <input type="number" className="admin-settings-input" defaultValue="8" min="6" max="20" />
                </div>
                
                <div className="admin-settings-form-group">
                  <div className="admin-settings-checkbox-wrapper">
                    <input type="checkbox" id="require-uppercase" className="admin-settings-checkbox" checked />
                    <label htmlFor="require-uppercase" className="admin-settings-checkbox-label">
                      Require uppercase letters
                    </label>
                  </div>
                </div>
                
                <div className="admin-settings-form-group">
                  <div className="admin-settings-checkbox-wrapper">
                    <input type="checkbox" id="require-numbers" className="admin-settings-checkbox" checked />
                    <label htmlFor="require-numbers" className="admin-settings-checkbox-label">
                      Require numbers
                    </label>
                  </div>
                </div>
                
                <div className="admin-settings-form-group">
                  <div className="admin-settings-checkbox-wrapper">
                    <input type="checkbox" id="require-special" className="admin-settings-checkbox" checked />
                    <label htmlFor="require-special" className="admin-settings-checkbox-label">
                      Require special characters
                    </label>
                  </div>
                </div>
                
                <div className="admin-settings-form-group">
                  <label className="admin-settings-label">Password Expiry (days)</label>
                  <input type="number" className="admin-settings-input" defaultValue="90" min="30" max="365" />
                  <p className="admin-settings-help-text">Set to 0 for no expiration</p>
                </div>
              </div>
              
              <div className="admin-settings-section">
                <h3 className="admin-settings-section-title">Login Settings</h3>
                
                <div className="admin-settings-form-group">
                  <div className="admin-settings-checkbox-wrapper">
                    <input type="checkbox" id="enable-2fa" className="admin-settings-checkbox" />
                    <label htmlFor="enable-2fa" className="admin-settings-checkbox-label">
                      Enable Two-Factor Authentication
                    </label>
                  </div>
                </div>
                
                <div className="admin-settings-form-group">
                  <label className="admin-settings-label">Maximum Login Attempts</label>
                  <input type="number" className="admin-settings-input" defaultValue="5" min="3" max="10" />
                </div>
                
                <div className="admin-settings-form-group">
                  <label className="admin-settings-label">Account Lockout Duration (minutes)</label>
                  <input type="number" className="admin-settings-input" defaultValue="30" min="5" max="60" />
                </div>
              </div>
              
              <div className="admin-settings-section">
                <h3 className="admin-settings-section-title">Session Settings</h3>
                
                <div className="admin-settings-form-group">
                  <label className="admin-settings-label">Session Timeout (minutes)</label>
                  <input type="number" className="admin-settings-input" defaultValue="30" min="5" max="120" />
                </div>
                
                <div className="admin-settings-form-group">
                  <div className="admin-settings-checkbox-wrapper">
                    <input type="checkbox" id="concurrent-sessions" className="admin-settings-checkbox" />
                    <label htmlFor="concurrent-sessions" className="admin-settings-checkbox-label">
                      Allow Concurrent Sessions
                    </label>
                  </div>
                </div>
              </div>
              
              <div className="admin-settings-actions">
                <button className="admin-settings-cancel-btn">Cancel</button>
                <button 
                  className="admin-settings-save-btn"
                  onClick={() => handleSave("Security")}
                >
                  Save Changes
                </button>
              </div>
            </div>
          )}
          
          {/* Placeholder panels for other tabs */}
          {(activeTab === 'academic' || activeTab === 'notifications' || 
            activeTab === 'billing' || activeTab === 'integrations' || 
            activeTab === 'logs') && (
            <div className="admin-settings-panel">
              <h2 className="admin-settings-panel-title">{activeTab.charAt(0).toUpperCase() + activeTab.slice(1)} Settings</h2>
              <div className="admin-settings-placeholder">
                <div className="admin-settings-placeholder-icon">⚙️</div>
                <p className="admin-settings-placeholder-text">
                  {activeTab.charAt(0).toUpperCase() + activeTab.slice(1)} settings configuration panel
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default AdminSettings